/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 10/26/16
 * Time: 17:36 AM
 */
define(function (require) {
    "use strict";
    var _ = require("underscore");

    var UrlUtilities = (function(){

        /**
         * change key in url to new value
         * @param url the original url
         * @param key the key to replace his value
         * @param val th enew value
         * @param keyValDelimiter the delimiter between key and value, Default value is '='
         * @param paramDelimiter the delimiter between parameters, Default value is '&'
         * @returns updated url where the key value replaced with val
         */
        var changeKeyInUrl = function (url, key, val, keyValDelimiter,paramDelimiter) {
            var newUrl = url;

            //if keyValDelimiter was not set set default delimiter
            if (!keyValDelimiter){
                keyValDelimiter = "=";
            }

            //if paramDelimiter was not set set default delimiter
            if (!paramDelimiter){
                paramDelimiter = "&";
            }

            if (_.isArray(key)) {
                _.each(key, function (currentKey, i) {
                    newUrl = setKeyInUrl(newUrl, currentKey, val[i], keyValDelimiter, paramDelimiter);
                });
            } else {
                newUrl = setKeyInUrl(newUrl, key, val, keyValDelimiter, paramDelimiter);
            }

            return newUrl;
        };

        var setKeyInUrl = function(url,key,val,keyValDelimiter, paramDelimiter) {
            var newUrl = url;
            // set the new key
            var newKey = key+ keyValDelimiter+val;
            // find the key location in the url
            var nStart = url.indexOf(key+ keyValDelimiter);
            // check if key exsist
            if(nStart>0){
                var nEnd = url.indexOf(paramDelimiter,nStart);
                var oldKey;
                // check if this is the last key
                if(nEnd == -1){
                    oldKey =url.substring(nStart);
                }else{
                    oldKey =url.substring(nStart,nEnd);
                }
                // update the url, replace the old key with the new one
                newUrl = url.replace(oldKey,newKey);
            } else { // add new key
                newUrl = url.slice(0,url.indexOf("?")+1)+newKey+ paramDelimiter +url.slice(url.indexOf("?")+1);
            }
            return newUrl;
        };

        return {
            changeKeyInUrl: changeKeyInUrl
        };

    })();

    return UrlUtilities;
});
